import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import { ChevronRight, ArrowRight, CheckCircle2 } from "lucide-react";
import { products } from "../mock";
import { Button } from "../components/ui/button";
import CtaCallback from "../components/CtaCallback";
import IndustriesWeDealIn from "../components/IndustriesWeDealIn";
import useSeo from "../hooks/useSeo";

export default function ProductsPage() {
  useSeo({
    title: "Our Products — Industrial IR Heaters",
    description: "Browse our range of premium shortwave IR heaters and reflector box heaters. Custom sizes, wattages, ISO 9001:2015 certified quality, OEM solutions.",
    keywords: "shortwave IR heater products, reflector box IR heater, PET preform heater, industrial heating products, OEM heater India",
    path: "/products",
  });
  return (
    <main>
      <PageHero
        tagline="Our Heating Solutions"
        title="Our"
        highlight="Products"
        subtitle="Premium quality industrial heating solutions engineered for performance and durability."
        crumb={(
          <div className="flex items-center gap-2">
            <Link to="/" className="hover:text-orange-500">Home</Link>
            <ChevronRight size={14} className="text-orange-500" />
            <span className="text-orange-500 font-semibold">Products</span>
          </div>
        )}
      />

      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-8">
          {products.map(p => (
            <div key={p.slug} className="lift-on-hover bg-cream rounded-2xl overflow-hidden border border-orange-100 relative">
              <span className="absolute top-4 right-4 z-10 bg-orange-500 text-white text-[10px] font-bold tracking-widest uppercase px-2.5 py-1 rounded-full">Premium</span>
              <div className="aspect-[4/3] bg-white flex items-center justify-center overflow-hidden">
                <img src={p.image} alt={p.name} className="w-full h-full object-contain" />
              </div>
              <div className="p-7">
                <h3 className="font-display text-2xl uppercase">{p.name}</h3>
                <span className="block w-12 h-[3px] bg-orange-500 mt-3" />
                <p className="mt-4 text-neutral-700 text-sm leading-relaxed">{p.short}</p>
                <ul className="mt-4 grid grid-cols-2 gap-y-1.5">
                  {p.features.slice(0, 4).map(f => (
                    <li key={f} className="flex items-start gap-2 text-xs text-neutral-800">
                      <CheckCircle2 size={14} className="text-orange-500 mt-0.5 shrink-0" />
                      {f}
                    </li>
                  ))}
                </ul>
                <Link to={`/products/${p.slug}`} className="inline-block mt-6">
                  <Button className="bg-orange-500 hover:bg-orange-600 text-white rounded-full px-6 uppercase tracking-wider font-semibold">
                    View Details <ArrowRight size={14} className="ml-2" />
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      <IndustriesWeDealIn />
      <CtaCallback />
    </main>
  );
}
